import { ErrorBoundary } from "@datadog/browser-rum-react";
import Loader from "core/components/Loader";
import FailureError from "core/error/FailureError";
import { ERROR_TYPES } from "core/constants";

const ApplicationErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary
      fallback={({ error, resetError }) => {
        console.info("ApplicationErrorBoundary", error);

        if (
          error?.message?.includes(
            "Failed to fetch dynamically imported module"
          )
        ) {
          window.location.reload();
          return <Loader />;
        }

        return (
          <FailureError
            resetError={resetError}
            type={ERROR_TYPES.APPLICATION_ERROR}
            error={error}
          />
        );
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default ApplicationErrorBoundary;
